import { setStorage, readStorage } from '@surglogs/hook.storage'

export const ACCESS_TOKEN_NAME = 'accessToken'
export const REFRESH_TOKEN_NAME = 'refreshToken'
export const SESSION_ID_NAME = 'sessionId'

export const setAccessTokenToStorage = (newAccessToken: string | null) =>
  setStorage(window.sessionStorage, ACCESS_TOKEN_NAME, newAccessToken)

export const getAccessTokenFromStorage = () =>
  readStorage<string>(window.sessionStorage, ACCESS_TOKEN_NAME)

export const setRefreshTokenToStorage = (newAccessToken: string | null) =>
  setStorage(window.sessionStorage, REFRESH_TOKEN_NAME, newAccessToken)

export const getRefreshTokenFromStorage = () =>
  readStorage<string>(window.sessionStorage, REFRESH_TOKEN_NAME)

export const setSessionIdToStorage = (sessionId: string) =>
  setStorage(window.sessionStorage, SESSION_ID_NAME, sessionId)

export const getSessionIdFromStorage = () =>
  readStorage<string>(window.sessionStorage, SESSION_ID_NAME)

const LAST_EXTERNAL_URL_TOKEN_NAME = 'lastExternalUrlToken'

export const setLastExternalUrlTokenToStorage = (token: string | null) =>
  setStorage(window.sessionStorage, LAST_EXTERNAL_URL_TOKEN_NAME, token)

export const getLastExternalUrlTokenFromStorage = () =>
  readStorage<string>(window.sessionStorage, LAST_EXTERNAL_URL_TOKEN_NAME)
